import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ReturnAttributionSelectComparisons from './pages/ReturnAttributionSelectComparisons/ReturnAttributionSelectComparisons';
import ReturnAttributionAnalysis from './pages/ReturnAttributionAnalysis/ReturnAttributionAnalysis';
import NavBarAlpha from './components/NavBarAlpha';
import NavBarBeta from './components/NavBarBeta';
import PennyMLFrame from './pages/PennyMLFrame/PennyMLFrame';
import AboutMe from './pages/AboutMe/AboutMe';
import PacingUpload from './pages/PacingUpload/PacingUpload';
import PacingAnalysis from './pages/PacingAnalysis/PacingAnalysis';
import 'antd/dist/antd.css';
import MarkdownRenderer from './pages/MarkdownRenderer/MarkdownRenderer';
import NotFound from './pages/NotFound/NotFound';
import HomePageAlpha from './pages/HomePageAlpha/HomePageAlpha';
import HomePageBeta from './pages/HomePageBeta/HomePageBeta';
import FitToTAUpload from './pages/FitToTAUpload/FitToTAUpload';
import FitToTAAnalysis from './pages/FitToTAAnalysis/FitToTAAnalysis';

// Layout wrapper component with conditional navbar
const AppLayout = ({ children }) => {
  const location = useLocation();
  const isinsights = location.pathname.startsWith('/insights');
  const isUBCIMAnalysis = location.pathname.startsWith('/ubc-im-analysis');

  return (
    <div className="min-h-screen h-screen w-full overflow-x-hidden bg-[#f0f4f5] flex flex-col">
      {!isUBCIMAnalysis && (isinsights ? <NavBarBeta /> : <NavBarAlpha />)}
      <main className="flex-1 w-full flex flex-col">
        {children}
      </main>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppLayout>
        <Routes>
          {/* Alpha Paths */}
          <Route path="/" element={<HomePageAlpha />} />
          <Route path="/manager-selection/tools/return-attribution" element={<ReturnAttributionSelectComparisons />} />
          <Route path="/manager-selection/tools/return-attribution/analysis" element={<ReturnAttributionAnalysis />} />
          <Route path="/manager-selection/research/quant-vs-fundamental" element={<MarkdownRenderer basePath="/notebooks/quant_vs_fundamental_manager_selection"/>} />

          <Route path="/tpm/tools/pacing" element={<PacingUpload />} />
          <Route path="/tpm/tools/pacing/analysis" element={<PacingAnalysis />} />

          <Route path="/tpm/tools/fit-to-ta" element={<FitToTAUpload />} />
          <Route path="/tpm/tools/fit-to-ta/analysis" element={<FitToTAAnalysis />} />

          <Route path="/tpm/research/market-efficiency" element={<MarkdownRenderer basePath="/notebooks/Market_Efficiency_Analysis"/>} />
          <Route path="/tpm/research/fundamental-quant-optimizer" element={<MarkdownRenderer basePath="/notebooks/optimizer"/>} />

          <Route path="/other/projects/penny-ml" element={<PennyMLFrame />} />
          <Route path="/other/research/evestment-bias" element={<MarkdownRenderer basePath="/notebooks/eVestment_biasses"/>} />

          <Route path="/about-me" element={<AboutMe />} />

          {/* Beta Paths */}
          <Route path="/insights/" element={<HomePageBeta />} />
          <Route path="/insights/manager-selection/tools/return-attribution" element={<ReturnAttributionSelectComparisons />} />
          <Route path="/insights/manager-selection/tools/return-attribution/analysis" element={<ReturnAttributionAnalysis />} />
          <Route path="/insights/manager-selection/research/quant-vs-fundamental" element={<MarkdownRenderer basePath="/notebooks/quant_vs_fundamental_manager_selection"/>} />

          <Route path="/insights/tpm/tools/pacing" element={<PacingUpload />} />
          <Route path="/insights/tpm/tools/pacing/analysis" element={<PacingAnalysis />} />

          <Route path="/insights/tpm/tools/fit-to-ta" element={<FitToTAUpload />} />
          <Route path="/insights/tpm/tools/fit-to-ta/analysis" element={<FitToTAAnalysis />} />

          <Route path="/insights/tpm/research/market-efficiency" element={<MarkdownRenderer basePath="/notebooks/Market_Efficiency_Analysis"/>} />
          <Route path="/insights/tpm/research/fundamental-quant-optimizer" element={<MarkdownRenderer basePath="/notebooks/optimizer"/>} />

          <Route path="/insights/other/projects/penny-ml" element={<PennyMLFrame />} />
          <Route path="/insights/other/research/evestment-bias" element={<MarkdownRenderer basePath="/notebooks/eVestment_biasses"/>} />

          <Route path="/insights/about-me" element={<AboutMe />} />

          <Route path="*" element={<NotFound />} />

          {/* No Nav Bar */}
          <Route path="/ubc-im-analysis/quant-vs-fundamental" element={<MarkdownRenderer basePath="/notebooks/quant_vs_fundamental_manager_selection" showCode={false}/>} />
          <Route path="/ubc-im-analysis/market-efficiency" element={<MarkdownRenderer basePath="/notebooks/Market_Efficiency_Analysis" showCode={false}/>} />
          <Route path="/ubc-im-analysis/fundamental-quant-optimizer" element={<MarkdownRenderer basePath="/notebooks/optimizer" showCode={false}/>} />
          <Route path="/ubc-im-analysis/evestment-bias" element={<MarkdownRenderer basePath="/notebooks/eVestment_biasses" showCode={false}/>} />

        </Routes>
      </AppLayout>
    </Router>
  );
};

export default App;
